import { UISDK } from "@/ui-sdk";
import { flagCheck } from "..";
import { Products } from "../low-ticket-recommendation/utils/get-low-ticket-size-recommendations";
import { Product } from "@/sdk/types";
import { extractSlugs, fetchOrderData } from "./utils";
import { CDN_URL } from "@/constants/cdn";

export default async function handleComplementaryStylesRecommendation(
  element: HTMLElement,
  sdk: UISDK,
) {
  const cdn = CDN_URL;

  function extractOrderId(url: string) {
    const match = url.match(/track\/([^?\s]+)/);
    return match ? match[1] : null;
  }

  function extractEmailFromElement(selector: string) {
    const element = document.querySelector(selector);
    if (element) {
      const match = element.innerHTML.match(/[\w.-]+@[\w.-]+\.[a-zA-Z]{2,}/);
      return match ? match[0] : null;
    }
    return null;
  }

  const orderId =
    typeof window !== "undefined"
      ? extractOrderId(window.location.pathname)
      : null;
  const jsSelector: string =
    "body > main > div > div > div.mx-auto.max-w-3xl.space-y-8 > div:nth-child(2) > div > p";
  const email = extractEmailFromElement(jsSelector);

  const orderProductData = await fetchOrderData(orderId, email);
  const productHandles = extractSlugs(orderProductData.data);

  const productWithSubcategory = (
    await Promise.all(
      productHandles.map(async (id: string) => {
        const product = await window.helium.datastore.getProduct({ id });
        const tags = await window.helium.datastore.getTags({ id });
        return {
          handle: product?.details?.id,
          subcategory: tags?.subcategory,
        };
      }),
    )
  ).filter((e) => !!e.handle);
  const complementaryStylesPromises = productWithSubcategory.map(({ handle }) =>
    fetch(
      `${cdn}/${window.helium.brandData.orgId}/complementary-styles/v3/${handle}/results.json`,
    ).then((res) => res.json()),
  );

  const allStylesPromises = productWithSubcategory.map(({ subcategory }) =>
    fetch(
      `${cdn}/${window?.helium.brandData.orgId}/complementary-styles/styles/${product?.tags?.subcategory?.toLowerCase().join("")}.json`,
    ).then((res) => res.json()),
  );

  const [complementaryStylesResults, allStylesResults] = await Promise.all([
    Promise.all(complementaryStylesPromises),
    Promise.all(allStylesPromises),
  ]);

  const productPositions: Record<string, string> = {};
  const allComplimentaryStylesWithProducts = {};

  await Promise.all(
    productWithSubcategory.map((e) => {
      return window.helium.datastore.getProduct({
        id: e.handle,
      });
    }),
  );

  for (let index = 0; index < productWithSubcategory.length; index++) {
    const { handle } = productWithSubcategory[index];
    const complementaryStyles = complementaryStylesResults[index] || {};
    const allStyles = allStylesResults[index] || {};
    const currentPosition = allStyles[0]
      .positionOfTheCurrentSubcategory as string;
    productPositions[handle] = currentPosition;
    const complementaryStylesWithProduct = { ...complementaryStyles };

    // Extract product IDs
    const totalIds: string[] = [];
    for (const style in complementaryStyles) {
      const subcategories = complementaryStyles[style];
      for (const subcategory of subcategories) {
        totalIds.push(...subcategory.results);
      }
    }

    const totalProducts = await Promise.all(
      totalIds.map(async (id) => {
        const product = await window.helium.datastore.getProduct({ id });
        return product.details;
      }),
    );

    for (const style in complementaryStyles) {
      const subcategories = complementaryStyles[style];
      for (const subcategory of subcategories) {
        const index = complementaryStylesWithProduct[style].findIndex(
          (s) => s.subcategory === subcategory.subcategory,
        );

        if (index !== -1) {
          const selectedProducts =
            complementaryStylesWithProduct[style][index].results;

          const products = totalProducts.filter((product) =>
            selectedProducts.includes(product.id),
          );

          complementaryStylesWithProduct[style][index].results = products;
        }
      }
      allComplimentaryStylesWithProducts[handle] =
        complementaryStylesWithProduct;
    }
  }
  return sdk.renderComplementaryStylesRecommendation(
    {
      c: [],
      s: [],
      key: Date.now().toString(),
      loading: false,
      productHandles: productWithSubcategory,
      complementaryStyles: allComplimentaryStylesWithProducts,
      productPositions,
    },
    element,
  );
}
